import {
  MenuOutlined,
  MoonOutlined,
  SunOutlined,
  SwapOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { setThemeString } from "@/store/modules/app";
import { useAppSelector, useAppDispatch } from "@/store";
import { Button, Avatar, Dropdown } from "antd";
import clsx from "clsx";
import { PageEnum } from "@/enums/pageEnum";
import { useNavigate } from "react-router-dom";
import { Logo, Smalllogo, AvatarImage } from "@/assets";
import { useTranslation } from "react-i18next";
import LoginButton from "@/components/LoginButton";
import AiCallNotifier from "@/components/AiCallNotifier";

export interface HeaderProps {
  collapsed?: boolean;
  onCollapse?: () => void;
}

const AppHeader = ({ onCollapse, collapsed }: HeaderProps) => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const darkMode = useAppSelector((state) => state.app.theme);
  const toggleDarkMode = () => {
    dispatch(setThemeString(darkMode === "light" ? "dark" : "light"));
  };

  const getButton = () => {
    return (
      <Button
        color="default"
        className="w-[calc(100%-37px)] py-2 pl-[20px] box-content leading-8"
        icon={<SwapOutlined />}
        variant="link"
        onClick={() => {
          navigation(PageEnum.CHOOSE_ORGAN, { state: { isSwitchOrgin: true } });
        }}
      >
        {t("switchOrgani")}
      </Button>
    );
  };

  return (
    <div className="flex bg-[#fff] dark:bg-[#141414]">
      <div
        className={clsx(
          collapsed ? "w-[64px]" : "w-[215px]",
          "bg-[#181D31] dark:bg-[#141414] border-b logoClass border-[#2C3358] transition-all duration-200 flex items-center justify-center"
        )}
      >
        <Button
          type="text"
          className="headerLogo h-[60px] px-[15px]"
          onClick={() => {
            navigation("/");
          }}
        >
          <img src={collapsed ? Smalllogo : Logo} alt="" srcSet="" />
        </Button>
      </div>
      <div className="border-b border-[#E5E6EB] dark:border-[#ffffff19] flex-1 flex items-center justify-between">
        <Button
          type="text"
          className="ml-[3px]"
          size="large"
          icon={<MenuOutlined />}
          onClick={() => {
            onCollapse?.();
          }}
        />
        <div className="pr-[15px] flex items-center justify-between">
          <AiCallNotifier />
          <Button
            type="text"
            className="mr-3"
            onClick={toggleDarkMode}
            icon={darkMode === "dark" ? <SunOutlined /> : <MoonOutlined />}
          />
          <Dropdown
            dropdownRender={() => {
              return (
                <div className="bg-[#fff] dark:bg-[#141414] cgboxShadow flex flex-col items-start">
                  {getButton()}
                  <LoginButton
                    icon={<LogoutOutlined />}
                    className="w-[calc(100%-35px)] py-2 pl-[20px] box-content leading-8 border-none justify-start text-[#000000e0]"
                  />
                </div>
              );
            }}
            arrow
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Avatar size={40} src={AvatarImage} />
            </a>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
